import { getApi, postApi } from "../apiCall";

export const getUserLCC = (token, type) => {
  let url = `${process.env.REACT_APP_API_URL}/category/getAll/public?type=${type}`;
  return getApi(url);
};

export const getLccStateAndUt = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/stateAndUt/getAll/public`;
  return getApi(url);
};

export const getLccEnergyType = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/energyType/getAll/public`;
  return getApi(url);
};

export const getDiscomByState = (token, stateId) => {
  let url = `${process.env.REACT_APP_API_URL}/discom/getByState/public?stateId=${stateId}`;
  return getApi(url);
};

export const getLccSubmit = (token, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/capacity/landing-cost/calculator/public`;
  return postApi(url, payload);
};
